export function getDeviceTypeSku(key) {
  const configStr = getLocalStoragItem('staticConfig');

  try {
    const config = JSON.parse(configStr || '');
    const deviceSku = config.DeviceSku || {};

    return deviceSku[key]['Default'] || [];
  } catch (e) {
    return []
  }
}

export function getShuangluDeviceInfo(gpList = [], device = {}) {
  const shuangluSkus = getDeviceTypeSku('Shuang_Lu');
  const isShuanglu = shuangluSkus.includes(device.ClassSku);

  if (!isShuanglu) return { isShuanglu: false }
  const configData = gpList;
  const childDeviceCountItem = configData.find(item => item.KeyId === 137) || {};
  const singleLampCountItem = configData.find(item => item.KeyId === 138) || {};

  const childDeviceCount = Number(childDeviceCountItem.DefaultValue) || 0;
  let singleLampCountModal = [];

  if (singleLampCountItem) {
    try {
      let mainValue = (singleLampCountItem.DefaultValue || '').slice(6);
     
      while (mainValue && mainValue.length) {
        singleLampCountModal.push(
          Number(parseInt(mainValue.substr(0, 2), 16))
        );

        mainValue = mainValue.slice(2)
      }
    
      // 首次进来没有值
      if (singleLampCountModal.length < childDeviceCount) {
        singleLampCountModal = singleLampCountModal.concat(
          new Array(childDeviceCount - singleLampCountModal.length).fill(0)
        );
      }  
    } catch (e) {
      
    };
    
  }

  return {
    isShuanglu: true,
    childDeviceCount,
    singleLampCounts: singleLampCountModal
  }
};